var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-el",class:{ active: _vm.isActive },attrs:{"href":_vm.href},on:{"click":_vm.go}},[_c('router-link',{attrs:{"to":_vm.href}},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }